import ReportVerbatim from './reportVerbatim'

export default ReportVerbatim
